import { Provider } from "react-redux";

/* REACT IMPORTS */
import React from "react";
import ReactDOM from "react-dom/client";

/* APP */
import AppRoutes from "routes/routes";

/* STORE */
import store from "./redux/store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppRoutes />
    </Provider>
  </React.StrictMode>
);
